import { AppTexts, StyleValues, TangentClassNames, ScreenNames } from './../../objects/app-static-texts';
import { Component, OnInit, ViewChildren, QueryList, HostListener, ViewChild, ElementRef} from '@angular/core';
import { CustomService } from '../../services/custom.service';
import { AppManagementService } from '../../services/app-management.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { QuestionBase } from '../../objects/question-base';
import { QuestionService } from '../../services/question.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  providers: [QuestionService]
})
export class SurveyComponent implements OnInit {
  @ViewChild('surveyContinue') surveyContinueBtn: ElementRef;
  @ViewChildren('selectionBtn') selectBtns!: QueryList<'selectionBtn'>;
  
  @ViewChild('photoInput') photoInput: ElementRef;
  matched_prev_options = [];

  // Mobile device check
  isMobile: boolean = false;

  matApperance: string = "fill";
  //SCREEN STYLE FOR INDIVIDUAL SCREEN
  survey_screen_style:any;

  // Flow List
  history_list= [];

  // Flag to enable backbutton
  enableBackBtn: boolean = true;
  
  pageDesignFlag: boolean =false;
  // PAGE OBJECT
  pageDesign: any;
    
  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;
  custom_previous_press = false;

  // VARIABLE FOR STORING CUSTOM CODE STRING
  htmlText: any;
  quizSteps: any;

  //GLOBAL FLAG TO CHECK IF USER CLICKED AN OPTION
  user_clicked:boolean = false;

  //ALL QUESTIONS OBJECT LIST
  questions_array: any;
  
  fileData: File = null;

  form_fields: any = [];
  form_present:boolean = false;
  inputStyle: any;

  surveySkip: any;
  surveyContinueButton: any;

  customDesignedLabels: any;
  customBulletPoints:any;
  selectedOptionStatus: boolean = false;

  aiSelectedValue:any;
  aiPoweredImgUrl: any;
  aiPoweredImgStyle: any;

  temp_opt:any;

  currentSelectedOption: any;
  currentBuildQuestion:any;
  
  currentQstOptions: any;
  question: any;
  subText: any;
  qst_img_obj: any;

  //NEXT BUTTON FLAG
  enableNextBtn: boolean = false;
  nextQuestionName: any;
  selectedOption: string;
  selectedOptionsArray: any;

  // Incase of multi-selection enabled for Survey
  multi_selection: boolean = false;
  multiOpts: any;

  previous_opt:any;

  //For survey option
  clickedBtn: any;

  ai_highlight_text_style:any;
  form: FormGroup;

  input_elements: QuestionBase<String>[];

  survey_options_container_style:any;
  currentQuestionBulletPoint: number = 0;

  constructor(
    private formBuilder: FormBuilder, 
    public appService: AppManagementService, 
    public customService: CustomService, 
    private questionService: QuestionService,
    private elRef: ElementRef) {
    this.selectedOptionsArray = [];
    this.multiOpts = [];
    this.currentQstOptions = [];
    this.currentQstOptions.pop();
    this.currentQstOptions.length = 0;
  }

  ngOnInit() {
    this.pageDesign = this.appService.getPageDesign();
    if(typeof this.pageDesign === 'object' && this.pageDesign!=undefined){
      this.isMobile = this.appService.isMobile;
      this.pageDesignFlag = true;
      // All Questions in array
      this.questions_array = this.appService.getSurvey();
      this.aiPoweredImgUrl = this.appService.getAIpoweredImg();
      this.aiPoweredImgStyle = this.appService.getAIpoweredImgClass();
      
      // CSS STYLE SET FOR AI SELECTED OPTION FROM JSON OBJECT
      this.ai_highlight_text_style = this.appService.applyStyles([AppTexts.AiHighLightTextStyle,TangentClassNames.tangentGlobalStyle,"tangent_ai_select_text_custom"]);

      //MAIN CONTAINER STYLE
      this.pageDesign[AppTexts.style] = this.appService.applyElementStyle(this.pageDesign);

      //IF CUSTOM CODE ENABLED, SHOW QUIZ STEPS
      if(this.pageDesign.custom_code_enabled){
        if(this.pageDesign.quiz_steps_code!=undefined){
          this.quizSteps = atob(this.pageDesign.quiz_steps_code);  
        }
      }

      //NORMAL ELEMENT FLOWS STACK LIST
      if(this.pageDesign.element_flow!=undefined){
        for (var t = 0; t < this.pageDesign.element_flow.length; t++) {
          this.pageDesign.element_flow[t][AppTexts.style] = this.appService.applyElementStyle(this.pageDesign.element_flow[t]);
        }
      }
      
      // TO FETCH SAVED SELECTIONS AND LOAD PREVIOUS QUESTION
      var selectedQueries = this.customService.getSelectedQueries();

      if (selectedQueries == undefined || selectedQueries.length == 0) {
        if(this.pageDesign.start_screen!=undefined){
          this.nextQuestionName = this.customService.checkForApiResponseMapping(this.pageDesign.start_screen);
        }
        else{
          var previous_clicked_btn = this.customService.getClickedBtn();
          if(previous_clicked_btn!=undefined){
            this.nextQuestionName = previous_clicked_btn.next_question; 
          }
          else{
            this.nextQuestionName = this.questions_array[0].name;
          }
        }
        this.loopToNextQuestion();
      } else {
        this.customService.surveyStarted = true;
        this.currentBuildQuestion =  this.customService.getCurrentQuestion();
        if(this.customService.isSurveyContinued()){
          //LOAD LAST ATTENEDED QUESTION
          this.selectedOptionsArray = selectedQueries;
          if(this.customService.isBackButtonClicked()){
            if(this.currentQuestionBulletPoint == this.questions_array.length){
              this.currentQuestionBulletPoint =  this.currentQuestionBulletPoint - 1;
            }
            else{
              this.currentQuestionBulletPoint =  this.questions_array.length;
            }
            this.previousQstn();
            this.customService.setBackButtonClicked(false);
          }
          else{
            this.nextQuestionName = this.customService.getClickedBtn().next_question;  
            if(this.nextQuestionName==undefined){
              var lst = this.appService.getScreenHistory();
              if(lst.length>0){
                this.nextQuestionName = lst[lst.length-1].name;
              }
            }
            this.loopToNextQuestion();
          }
        } 
      }
    
      setTimeout(() => {
        this.updateIframeHeight();
        this.captureImageLoadEvent();
      }, 300);
    }
    else{
      this.appService.redirectAppToBase();
    }
  }

  
  buildQuestion(qtn) {
    // To detect inputs on survey questions
    var inputs = this.customService.inputs_data;
    var image_element;
    this.history_list = this.appService.getScreenHistory();

    // Scenario to handle if first load screen is Survey
    if(this.appService.startScreen== ScreenNames.survey && this.history_list.length==0){
      this.enableBackBtn = false;
    }
    else{
      this.enableBackBtn = true;
    }

    this.temp_opt = null;
    // RESET EACH TIME NEW QUESTION LOADS
    this.user_clicked = false;

    this.surveySkip = null;
    this.surveyContinueButton = null;

    if(qtn.skip_option!=undefined){
      // Fixed variable For skip Option in survey
      this.surveySkip = qtn.skip_option;
      // Fixed variable For contine button in survey
      var survey_skip_btn_style = this.findClassStyle(qtn.skip_option);
      var skip_custom_class = [qtn.qID+"_survey_skip_button_custom"];
      if(this.isMobile){
        skip_custom_class.push(qtn.qID+"_survey_skip_button_mob_custom")
      }
      var custom_survey_skip_btn_style = this.appService.applyStyles(skip_custom_class)
      let merged_survey_skip_btn_style = {...survey_skip_btn_style, ...custom_survey_skip_btn_style};
      this.surveySkip.style = merged_survey_skip_btn_style; 
    }
    
    if(qtn.continue_option!=undefined){
      this.surveyContinueButton = qtn.continue_option;
      // Fixed variable For contine button in survey
      var continue_btn_style = this.findClassStyle(qtn.continue_option);
      var continue_custom_class = [qtn.qID+"_survey_next_button_custom"];
      if(this.isMobile){
        continue_custom_class.push(qtn.qID+"_survey_next_button_mob_custom")
      }
      var custom_continue_btn_style = this.appService.applyStyles(continue_custom_class)
      let merged_continue_btn_style = {...continue_btn_style, ...custom_continue_btn_style};
      this.surveyContinueButton.style = merged_continue_btn_style;  
    }
    
    // SCROLL TO TOP 
    this.appService.scrollToTop();

    setTimeout(() => { this.updateIframeHeight(); }, 300);
    
    // RESET IMAGE OBJECT
    this.qst_img_obj = null;

    // NEXT BUTTON ENABLING IF ITS NOT AUTO NAVIGATE
    this.enableNextBtn = !qtn.auto_nav;

    // CONVERT QUESTION TEXT TO SLUG TEXT FOR GA STORAGE
    this.createSlugForGA(qtn);
    this.customService.setCurrent_question_id(qtn.qID);
    
       
    for(var e=0;e<this.pageDesign.element_flow.length;e++){
      if(this.pageDesign.element_flow[e].type=="image"){
        image_element = this.pageDesign.element_flow[e];
      }
      if(this.pageDesign.element_flow[e].survey_name!=undefined){
        if(this.pageDesign.element_flow[e].type == "custom" && this.pageDesign.element_flow[e].survey_name == qtn.name){
          this.pageDesign.element_flow[e].custom_html = atob(this.pageDesign.element_flow[e].custom_code);
        }
        else{
          this.pageDesign.element_flow[e].custom_html = "";
        }
      }
    }

    //SENDING PAGE VIEW FOR GA FOR EACH NEW QUESTION
    this.customService.sendPageViewUpdate(this.pageDesign.name);

    this.matched_prev_options.length = 0;

    //GLOBAL QUESTION VARIABLE ASSIGNED
    this.currentBuildQuestion = qtn;
    
    // STYLE FOR OPTIONS CONTAINER
    var options_container_classes = ["tangent_options_container_style","tangent_options_container_custom","tangent_options_container_mob_custom",this.currentBuildQuestion.qID+"_options_container_custom"];
    if(this.isMobile){
      options_container_classes.push(this.currentBuildQuestion.qID+"_options_container_mob_custom");
    }
    
    this.survey_options_container_style = this.appService.applyStyles(options_container_classes);
    
    //IF PAGE DESIGN HAVE CUSTOM CODE
    if(this.pageDesign.custom_code_enabled){ this.loadCustomQuestionScreen(qtn); }

    // QUESTION TEXT
    // FOR INDIVIUAL CUSTOM ELEMENT TO LOAD AS QUESTION
    this.setQuestionText(qtn, inputs);
  

    // QUESTION SUBTEXT
    this.subText = qtn.subText;
    
    // IF QUESTION HAS IMAHE
    if(qtn.image!=undefined){

      //IF IMAGE IS DYNAMIC
      if(qtn.image.dynamic!=undefined){
        var cust_img_id = this.customService.getDatabySearch(qtn.image.dynamic);
        qtn.image.src = "https://s.tangent.ai/user-image/"+this.appService.client_config.user+"/"+cust_img_id;
      }
        
      this.qst_img_obj = qtn.image;
      var img_style = this.findClassStyle(image_element);
      var custom_img_style = this.appService.applyStyles([this.currentBuildQuestion.qID+"_question_image_custom"])
      let merged_image_style = {...img_style, ...custom_img_style};
      this.qst_img_obj[AppTexts.style] = merged_image_style;      
    }

    // MULTI-SELECTION 
    this.multi_selection = qtn.multi_selection;

    // ALL OPTIONS IN QUESTION
    var options_list = qtn.select_map;
    
    // RESET SELECTIONS FOR MULTI_SELECTIONS QUESTION
    this.multiOpts.length = 0;

    // RESET OPTIONS FOR CURRENT QUESTION
    this.currentQstOptions.length = 0;

    // Flag Variable to highlight only one value
    var enableSingleAI = true;

    // DISABLE FORM UI BY DEFAULT
    this.form_present = false;

    switch (qtn.response_type) {
      case 'user_input':
        this.createInputElementUIArray();
        break;

      default:
        this.selectedOptionStatus = false;   

        //LOOP OPTIONS
        for (var key in options_list) {
          var tempKey = key
          var apiKeyData =null;

          //IF no TAG value is present
          if (options_list[tempKey].tag != AppTexts.Null) {
            var c_tags=[];
            if (options_list[tempKey].tag.indexOf('|') > -1){
              c_tags = options_list[tempKey].tag.split('|');
            }
            else{
              c_tags.push(options_list[tempKey].tag);
            }

            // Multiple tags with a selection highlight tag
            for(var cTag=0; cTag<c_tags.length; cTag++){
              if(apiKeyData==undefined){
                apiKeyData = this.customService.checkMatchWithSelfieTag(c_tags[cTag]);
              }
            }
            
          }
        
          // OPTION IMAGE CLASS ARRAY
          var opt_img_classes = [];
        
          // IF IMAGE IS AVAILABLE FOR OPTIONS
          if(options_list[tempKey].img!=undefined){
            if (options_list[tempKey].img.class != undefined) {
              opt_img_classes = options_list[tempKey].img.class;
            }
          }
          opt_img_classes.push(this.currentBuildQuestion.qID+"_option_image_custom")
          
          if (apiKeyData!=undefined && enableSingleAI) {
            this.aiSelectedValue = options_list[tempKey];
            this.selectedOptionStatus = true;            
          } 

          var previous_selected = false;
          
          //IF A PREVIOUS SELECTED OPTION IS PRESENT
          if(this.previous_opt!=undefined && this.previous_opt.optVal!=undefined){
            if(this.previous_opt.optVal.id == options_list[key].id){
              previous_selected = true;
              this.matched_prev_options.push(options_list[key]);
            } 
          }
          var opt_text_class = [];
          
          if(options_list[tempKey].val_style_class != AppTexts.Null && options_list[tempKey].val_style_class !=undefined){
            opt_text_class = options_list[tempKey].val_style_class;
          }
          opt_text_class.push("tangent_option_text_custom");
          opt_text_class.push(this.currentBuildQuestion.qID+"_option_text_custom");
    
          if(this.isMobile){
            opt_text_class.push(this.currentBuildQuestion.qID+"_option_text_mob_custom");
          }
          
          // OPTION CLASS ARRAY
          var opt_classes = this.appService.getNormalSelectClass(this.currentBuildQuestion);

          //BUILDING OPTION
          var option ={};
          option[AppTexts.Type] = AppTexts.question;
          option[AppTexts.OptionID] = tempKey;
          option[AppTexts.OptionValue] = options_list[key];
          option[AppTexts.OptionQuestion] = qtn.question;
          option[AppTexts.QuestionID] = qtn.qID;
          option[AppTexts.QuestionnName] = qtn.name;
          option["optionClasses"]= "option_selection";
          if(options_list[key].priority!=undefined){
            option['priority'] = options_list[key].priority;
          }
          option[AppTexts.OptionImageStyle] = this.appService.applyStyles(opt_img_classes);
          option[AppTexts.OptionStyle] = this.appService.applyStyles(opt_classes);
          option[AppTexts.OptionTextStyle] = this.appService.applyStyles(opt_text_class);
          option[AppTexts.OptionDataMap] = apiKeyData;     
          
          if(previous_selected){
            option["optionClasses"] = "option_selection highlighted_selection";
            this.currentSelectedOption = option;
            this.customService.setHighlightedOption(option);
            this.selectedOptionStatus = false;
            enableSingleAI = false;
          }
          this.currentQstOptions.push(option);
        }

        for (var c =0;c < this.currentQstOptions.length;c++) {
          if(this.currentQstOptions[c].api_data!=undefined){
            var apiDt =  this.currentQstOptions[c].api_data;
            if(apiDt.exceptions!=undefined){
              var ques = this.currentQstOptions[c];
              if(this.temp_opt==undefined || this.temp_opt == null){
                this.currentQstOptions = this.updateAISelected(ques);  
              }
            }
          }
        }
        if(this.temp_opt!=undefined || this.temp_opt != null){
          for (var e =0;e < this.currentQstOptions.length;e++) {
            if(this.temp_opt.optVal.tag == this.currentQstOptions[e].optVal.tag){
              this.currentQstOptions[e].api_data = null;
              var opt_classes = this.appService.getNormalSelectClass(this.currentBuildQuestion);
              
              this.currentQstOptions[e]['opt_style']= this.appService.applyStyles(opt_classes);
            }
          }
        }

        if(this.matched_prev_options.length>0){
          for(var mOpt=0; mOpt<this.matched_prev_options.length; mOpt++){
            for(var cOpt=0; cOpt<this.currentQstOptions.length; cOpt++){
              if(this.matched_prev_options[mOpt]['val'] ==  this.currentQstOptions[cOpt]['optVal']['val']){
                this.currentQstOptions[cOpt].optionClasses = "option_selection highlighted_selection";
                opt_classes = this.appService.getSelectionHighlightCss(this.currentBuildQuestion);
              }
              else{
                this.currentQstOptions[cOpt].optionClasses = "option_selection";
                opt_classes = this.appService.getNormalSelectClass(this.currentBuildQuestion);
              }
              this.currentQstOptions[cOpt]['opt_style']=this.appService.applyStyles(opt_classes);
            }
          }
        }
        
        if(this.multi_selection && this.previous_opt!=undefined){
          for(var s=0;s<this.selectedOptionsArray.length;s++){
            if(this.selectedOptionsArray[s].qName == this.previous_opt.qName){
              for(var c=0;c<this.currentQstOptions.length;c++){
                if(this.currentQstOptions[c].optID == this.selectedOptionsArray[s].optID){
                  this.addToMultiSelection(this.selectedOptionsArray[s]);
                  this.currentQstOptions[c] = this.applyHighLightSelectionCSS(this.currentQstOptions[c]);
                }
              }
            }
          }

          this.enableNextBtn = true;
        }

        break;
    }
    
    this.previous_opt = undefined;
    this.captureImageLoadEvent();
    
  }
  setQuestionText(qtn: any, inputs) {
    if(qtn.custom_question){
      this.question = "";
    }
    else{
      this.question =  eval('`'+qtn.question+'`');
    }
  }

  // IMAGE LOAD EVENT CAPTURE
  captureImageLoadEvent(){
    var imgs = document.querySelectorAll('img')
    for(var im=0;im<imgs.length;im++){
      if (imgs[im].complete) {
        this.updateIframeHeight()
      } else {
        imgs[im].addEventListener('load', this.updateIframeHeight)
        imgs[im].addEventListener('error', function() { })
      }
    } 
  }

  updateAISelected(qst){
    var apiDt = qst.api_data;
    var change = false;
    var pos =0;
    for(var ex=0;ex<apiDt.exceptions.length;ex++){
      var exc = apiDt.exceptions[ex];
      var search_result = this.customService.getDatabySearch(exc.key);
     
      for (var cq =0;cq < this.currentQstOptions.length;cq++) {
        var opt_classes;
        
        if(this.currentQstOptions[cq].optVal.tag==exc.replace && search_result==apiDt.exceptions[ex].value){
          if(this.temp_opt==undefined || this.temp_opt == null){
            this.temp_opt = qst;
          }
          change = true;
          pos=cq;
        }
      }
    }

    if(change){
      
      this.currentQstOptions[pos].api_data = apiDt;
      opt_classes = this.appService.getSelectionHighlightCss(this.currentBuildQuestion);
      
      this.currentQstOptions[pos][AppTexts.OptionStyle] = this.appService.applyStyles(opt_classes);
        
      this.aiSelectedValue = this.currentQstOptions[pos];
      this.currentSelectedOption = this.currentQstOptions[pos];
            
    }
    return this.currentQstOptions;
  }


  findClassStyle(element){
    if(element.classes!=undefined){
      var mob = []
      var common = element.classes.common;
      if(this.isMobile){
        if(element.classes.mobile!=undefined){
          mob =element.classes.mobile;
        }
      }
      const final_classes =  common.concat(mob);
      return this.appService.applyStyles(final_classes);      
    }
    else{
      return null;
    }
  }

  loadNext(opt, ele, select_btn ) {

    // ADD TO SCREEN HISTORY
    this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);
    this.clickedBtn = ele;
    
    // When more than one selection possible
    if (this.multi_selection) {
      //ENABLES NEXT BUTTON IF QUESTION IS MULTI-CHOICE
      this.enableNextBtn = true;
      if(this.currentBuildQuestion.validations == undefined){
        this.currentBuildQuestion.validations = {
          min_select:1,
          max_select: this.currentQstOptions.length
        };
      }

      if (this.multiOpts.length > 0 && this.multiOpts.length<this.currentBuildQuestion.validations.max_select) {
        var index = this.checkInMultiSelection(opt);
        opt = this.applyHighLightSelectionCSS(opt);
        if (index > -1) {
          //REMOVE SELECTION FROM LIST & REMOVE SELECTION STYLE
          this.removeFromMultiSelection(index);
          opt = this.applyNormalSelectionCSS(opt);
          this.removeFromSelectedOptionList(opt.optVal);
        }
        else{
          this.addToMultiSelection(opt);
        }
      } else {
        if(this.multiOpts.length == 0){ 
          opt = this.applyHighLightSelectionCSS(opt);
          this.addToMultiSelection(opt);
        }
        else{
          var found = false;
          var removeIndex =-1;

          // TO REMOVE IT FROM FINAL SELECTION ARRAY
          for(var o=0;o<this.selectedOptionsArray.length;o++){
            if(this.selectedOptionsArray[o].optID == opt.optID){
              for(var c=0;c<this.currentQstOptions.length;c++){
                // Remove Selection
                if(this.currentQstOptions[c].optID == this.selectedOptionsArray[o].optID){
                  removeIndex = o;
                  var opt_classes = this.appService.getNormalSelectClass(this.currentBuildQuestion);
                  this.currentQstOptions[c].opt_style = this.appService.applyStyles(opt_classes);
                  found = true;
                }
              }
            }
          }

          var index = this.checkInMultiSelection(opt);
          opt = this.applyNormalSelectionCSS(opt);
          
          if (index > -1) {
            this.removeFromMultiSelection(index);
          }
          else{
            // Display message at bottom of content
            var rect= this.surveyContinueBtn["_elementRef"].nativeElement.getBoundingClientRect();
            this.customService.openSnackBarMessage(this.currentBuildQuestion.validations.max_select_message,rect.bottom,'top');
          }

          if(found){
            this.selectedOptionsArray.splice(removeIndex, 1);
          }
        }
      }
    } else {
      
      this.nextQuestionName = this.findNextQName(opt);
      switch (this.nextQuestionName) {
        case 'end': {
          // CASE : AUTO SELECTION ENABLED 
          if(this.enableNextBtn){
            this.currentSelectedOption = opt;
            this.changeOptionSelectionStyle(select_btn);
          } else {
            this.addToSelectedOptionList(opt);
            this.customService.saveSelectedQueries(this.selectedOptionsArray);
            this.customService.triggerFunction(ele);
          }
          
          opt = this.applyHighLightSelectionCSS(opt);
          break;
        
        }
        case 'deny': {
          // this.messageStatus = true;
          break;
        
        }
        default: {
          // CASE : AUTO SELECTION ENABLED 
          if (this.enableNextBtn) {
            this.currentSelectedOption = opt;
            this.changeOptionSelectionStyle(select_btn);
          } else {
            var flag = true;
            var removeEle = -1;
            for(var o=0;o<this.selectedOptionsArray.length;o++){
              // TO REMOVE ANY SAVED OPTION FROM THE SAME QUESTION AS IT IS SINGLE SELECT
              if(this.selectedOptionsArray[o].qName == opt.qName) { 
                removeEle = o;
              }
              else{
                if(this.selectedOptionsArray[o].optID == opt.optID){
                  flag = false;        
                }
              }
            }
            
            // Element found
            if(removeEle>-1) { this.selectedOptionsArray.slice(removeEle,1); }

            // TAG is available for current selected option, adding to GA
            if(flag) { this.addToSelectedOptionList(opt); }
            
            this.nextQuestionName = this.findNextQName(opt);
            if(this.nextQuestionName=="screen_switch"){
              this.customService.routeToScreen(this.currentBuildQuestion.next.screen_name);
            } else {
              this.loopToNextQuestion();
            }
            
            this.customService.saveSelectedQueries(this.selectedOptionsArray);
          }
          break;
        }
      }
    }
  }

  // For changing selection option style
  changeOptionSelectionStyle(selected_button){
    var opt_btns = this.selectBtns["_results"];
    for ( var sl = 0; sl < opt_btns.length ; sl++) {
      if (selected_button.value != opt_btns[sl].value) {
        //RESET OPTION SELECTION
        var normal_opt_class = this.appService.getNormalSelectClass(this.currentBuildQuestion);
        var style = JSON.stringify(this.appService.applyStyles(normal_opt_class));
        var newNormalStyle = style.replace(/",/g, '";' );
        newNormalStyle = newNormalStyle.replace(/"/g, '');
        newNormalStyle = newNormalStyle.replace(/{/g, '');
        newNormalStyle = newNormalStyle.replace(/}/g, '');
        opt_btns[sl]._elementRef.nativeElement.setAttribute(AppTexts.style, newNormalStyle);
      } else {
        var highlight_opt_class = this.appService.getSelectionHighlightCss(this.currentBuildQuestion);
        
        var style = JSON.stringify(this.appService.applyStyles(highlight_opt_class));
        var newHighlightStyle = style.replace(/",/g, '";' );
        newHighlightStyle = newHighlightStyle.replace(/"/g, '');
        newHighlightStyle = newHighlightStyle.replace(/{/g, '');
        newHighlightStyle = newHighlightStyle.replace(/}/g, '');
        selected_button._elementRef.nativeElement.setAttribute(AppTexts.style, newHighlightStyle);
      }
    }
  }

  continueBtn() {
    //Resetting FLAG value
    var redirect = true;
    if(this.multi_selection) {
      if(this.multiOpts.length>0){
        if(this.currentBuildQuestion.validations == undefined){
          this.currentBuildQuestion.validations = {
            min_select:1,
            max_select: this.currentQstOptions.length
          };
        }

        if (this.multiOpts.length <this.currentBuildQuestion.validations.min_select) {
          redirect = false;
          // Display message at bottom of content
          var rect= this.surveyContinueBtn["_elementRef"].nativeElement.getBoundingClientRect();
          this.customService.openSnackBarMessage(this.currentBuildQuestion.validations.min_select_message,rect.bottom,'top');
        } 
        else {
          this.removeCurrentQuestionPreviousAnswers();
          var selected_opt = -1;
          for (var m=0; m<this.multiOpts.length; m++){
            if(this.multiOpts[m].priority!=undefined){
              if(this.multiOpts[m].priority<selected_opt || selected_opt <0 ){
                selected_opt = m;
              }
            }
            this.currentSelectedOption = this.multiOpts[m];
            this.addToSelectedOptionList(this.multiOpts[m]);
          }
          if(selected_opt>-1) { this.currentSelectedOption = this.multiOpts[selected_opt];}
        }
      }
      else{

        redirect = false;
        var count =1;
        var message;
        if(this.currentBuildQuestion.validations!=undefined){
          if(this.currentBuildQuestion.validations.min_select!=undefined){
            count = this.currentBuildQuestion.validations.min_select;
          }
        }
        if(count>1) {
          message = $localize`Please select at least ${count} options`;
        }
        else{
          message = $localize`Please select at least ${count} option`;
        }

        // Display message at bottom of content
        var rect= this.surveyContinueBtn["_elementRef"].nativeElement.getBoundingClientRect();
        this.customService.openSnackBarMessage(message,rect.bottom,'top'); 
      }
    }
    else{
      if(this.currentSelectedOption!=undefined){
        if(this.currentSelectedOption.optVal.tag !="null"){
          if(this.aiSelectedValue!=undefined && this.aiSelectedValue.val !=this.currentSelectedOption.optVal.val){
            var chg = "From "+this.aiSelectedValue.val+" to "+this.currentSelectedOption.optVal.val;
            var dt = {
              from_option: this.aiSelectedValue.val,
              to_option: this.currentSelectedOption.optVal.val
            }
            this.appService.sentEventData(AppTexts.clickEventName,'Option','Changed',chg,dt);
          } 
          var opt = {option: this.currentSelectedOption.optVal.tag};
          this.appService.sentEventData(AppTexts.clickEventName, 'Tag', 'Selected', this.currentSelectedOption.optVal.tag, opt);
        }
        this.selectedOptionsArray.push(this.currentSelectedOption);
      }
    }
    
    if(redirect){
      
      this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);
      this.nextQuestionName = this.findNextQName(this.currentSelectedOption);
      this.customService.saveSelectedQueries(this.selectedOptionsArray);
      if(this.nextQuestionName == "end"){
        if(this.pageDesign.element_flow.length>0){
          var eles = this.pageDesign.element_flow;
          for(var e=0;e<eles.length;e++){
            if(eles[e].type == AppTexts.multiOptionElement) { this.clickedBtn = eles[e]; }
          }
        }
        this.customService.triggerFunction(this.clickedBtn);
      }
      else{
        this.loopToNextQuestion();
      }
    }
  }

  removeCurrentQuestionPreviousAnswers(){
    for(var o=0;o<this.selectedOptionsArray.length;o++){
      if(this.selectedOptionsArray[o].qName == this.currentBuildQuestion.name) {
        this.selectedOptionsArray.splice(o, 1);
      }
    }
  }

  previousQstn() {
    // Screen loaded history
    this.history_list = this.appService.getScreenHistory();

    // Screen path from where previous called
    var current_screen = this.appService.current_screen_path;
    if(this.history_list.length >0){
      // Select previous screen 
      var next_screen = this.history_list[this.history_list.length-1];
      if(this.currentBuildQuestion!=undefined){
        if(next_screen.name == this.currentBuildQuestion.name){
          // this.appService.popFromScreenHistory();
          this.history_list = this.appService.getScreenHistory();
          if(this.history_list.length >0){
            next_screen = this.history_list[this.history_list.length-1];
          }
          else{
            var selected_queries = this.customService.getSelectedQueries();
            var flg = false;
            if(selected_queries!=undefined && selected_queries.length>0) { flg = true; }
            
            if(flg) {
              if(selected_queries.length<1) { this.customService.surveyStarted = false; }
            }
            this.appService.loadPrevious();
          }
        }
      }
      
      if(next_screen.type == AppTexts.page){
        this.appService.loadPrevious();
      }
      else{
        this.appService.popFromScreenHistory();
        // Check for next screen object to load
        for (var q = 0; q < this.questions_array.length; q++) {
          if (this.questions_array[q].name == next_screen.name) {
            var question_obj =this.questions_array[q];
            
            this.currentQuestionBulletPoint = this.currentQuestionBulletPoint -1;
            // CUSTOM CODE SECTION
            if(this.pageDesign.custom_code_enabled){
              setTimeout(() => {
                this.customDesignedLabels = document.getElementsByClassName("select-btn");
                
                //RESET ALL SELECTIONS
                for(var l=0;l<this.customDesignedLabels.length;l++){
                  this.customDesignedLabels[l].classList.remove(AppTexts.highlight_selection);
                }

                var opt_highlight = false;
                var pre_opt = this.selectedOptionsArray[this.selectedOptionsArray.length-1];
                if(question_obj.multi_selection){
                  if(this.selectedOptionsArray.length>0){
                    for(var s=0;s<this.selectedOptionsArray.length;s++){
                      if(this.selectedOptionsArray[s].qName == pre_opt.qName){
                        opt_highlight = true;
                        this.highlightCustomOption(this.selectedOptionsArray[s].optVal);
                      }
                    }
                  }
                }
                if(!opt_highlight){
                  this.highlightCustomOption(pre_opt.optVal);
                }
                this.custom_previous_press = false;
                this.updateIframeHeight();

              }, 1000);

            }
            // Check and remove selections from current screen
            if(this.selectedOptionsArray.length > 0) {
              var i = this.selectedOptionsArray.length-1;
              if(!this.customService.isBackButtonClicked()){   
                while (i>0) {
                  if (this.selectedOptionsArray[i].qName == this.currentBuildQuestion.name) { 
                    this.selectedOptionsArray.pop(); 
                  } 
                  i=i-1;
                }
              }

              this.previous_opt =this.selectedOptionsArray[this.selectedOptionsArray.length-1];
              if(this.previous_opt.screen_name!=undefined){
                this.customService.routeToScreen(this.previous_opt.screen_name);
              }
              else{
                this.currentSelectedOption = this.previous_opt;
              }
            }
            this.buildQuestion(question_obj);
          }
        }
      }
    }
    else{
      var selected_queries = this.customService.getSelectedQueries();
      var flg = false;
      if(selected_queries!=undefined && selected_queries.length>0) { flg = true; }
      
      if(flg) {
        if(selected_queries.length<1) { this.customService.surveyStarted = false; }
      }
      this.appService.loadPrevious();
    }

    this.customService.saveSelectedQueries(this.selectedOptionsArray);
     
    // BACK CLICK EVENT OBJECT FOR ANALYTICS
    var back_btn_obj = {
      from : current_screen,
      to: this.appService.current_screen_path
    }
    this.appService.sentEventData(AppTexts.clickEventName, AppTexts.ButtonCategory, AppTexts.ClickAction, 'back', back_btn_obj);
  }

  // Submit Function for Questions with Input 
  submitFormFunction(submit_button, form){
    var submit = true;
    var option_object = { };
    this.customService.saveSurveyForm(form.value);
    
    const keys = Object.keys(form.value);
    // ADDED BACK FUNCTIONALITY SINCE IT REQUIRES name TO LOAD ON PREVIOUS BUTTON CLICK
    option_object[AppTexts.Type] = AppTexts.question;
    // name REQUIRED FOR PICKING PREVIOUS QUESTION
    option_object[AppTexts.QuestionnName]= this.currentBuildQuestion.name;

    // Custom Validations for Inputs
    var form_values = form.value;
    var message;
    for (const key in form_values) {
      var form_input_value = form_values[key];
      
      this.customService.inputs_data[key] = form_input_value;
      if(this.isInputRequired(key) && this.isInputEmpty(form_input_value)){
        submit = false;
        message = "Please enter your value";
      }
      else if(this.isEmailError(form.get(key))){
        submit = false;
        message = "Please enter a valid email";
      }
      else if(this.hasCustomValidation() && !this.isCustomValidated(key,form_input_value)){
        submit = false;
        message = "Please enter a valid input";
      }
      else{
        message = "";
      }    
      this.setInputValidateResponseMessage(key, message);
    }
    if(submit){
      
      this.sendSubmitToAnalytics(form_values);

      this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);
      option_object["value"] = form_values;
      
      this.selectedOptionsArray.push(option_object);
      this.customService.saveSelectedQueries(this.selectedOptionsArray);
      this.customService.setCurrentQuestion(this.currentBuildQuestion);

      this.setNextQuestionByName(submit_button[AppTexts.NextQuestion]);
      
      if(submit_button.function_name==AppTexts.NextQuestion){
        this.buildQuestion(this.currentBuildQuestion);
      }
      else{
        this.customService.triggerFunction(submit_button);
      }
    }    
  }

  sendSubmitToAnalytics(values){
    var labelText = "Input Submit "+Object.keys(values).join(",");
    this.appService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,labelText,'');
  }

  sendSkipToAnalytics(){
    var labelText = "Input Skip "+this.customService.slugTextValue;
    this.appService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,labelText,'');
  }

  isInputEmpty(form_input_value){
    return form_input_value=="" || form_input_value == null ? true : false;
  }

  isInputRequired(key){
    for(var f=0;f<this.form_fields.length;f++){
      if(this.form_fields[f].key == key){
        return this.form_fields[f].required;
      }
    }
    return true;
  }

  hasCustomValidation(){
    return this.appService.getExternalValidations() ? true : false;
  }

  isEmailError(email_control){
    return email_control.hasError('email')  
  }
  
  // LOG : NEED TO WORK ON RESPONSE MESSAGE
  // Key of the input where validation should apply
  isCustomValidated(key, value){
    var custom_validations = this.appService.getExternalValidations();
    if(custom_validations[key]!=null){
      var custom_function = new Function('inp_value',custom_validations[key]);
      return custom_function(value);
    }
    else{
      return true;
    }
  }

  setInputValidateResponseMessage(key, message){
    for (var e = 0; e < this.form_fields.length; e++) {
      if(this.form_fields[e]['key']==key){
        this.form_fields[e]['hint']= message;
      }
    }
  }

  setNextQuestionByName(question_name){
    for (var q = 0; q < this.questions_array.length; q++) {
      if (this.questions_array[q].name == question_name) {
        this.currentBuildQuestion = this.questions_array[q];
      }
    }   
  }

  // SAVING SLUG TEXT FOR GA
  createSlugForGA(qtn){
    var full_text = qtn.question;
    if(qtn.question==undefined) { full_text = qtn.subText; }
    this.customService.slugText(full_text);
  }

  //FIND NAME OF NEXT OPTION
  findNextQName(selectedOption){
    var nextQtnName = '';
    //Loop through all questions 
    for (var q = 0; q < this.questions_array.length; q++) {
      if (this.questions_array[q].name == selectedOption.qName) {
        this.currentBuildQuestion = this.questions_array[q];
        if (this.currentBuildQuestion.next[selectedOption.optID] != undefined) {
          nextQtnName = this.currentBuildQuestion.next[selectedOption.optID];
        } else {
          nextQtnName = this.currentBuildQuestion.next.default;
        }
      }
    }
    return nextQtnName;
  }

  //ADDING TO SELECTED LIST AND SENDING GA LOG
  addToSelectedOptionList(option){
    this.sendToGA(option);
    var flg = true;
    if(this.selectedOptionsArray.length>0){
      for(var s=0;s<this.selectedOptionsArray.length;s++){
        if(this.selectedOptionsArray[s].optVal!=undefined && option.optVal!=undefined){
          if(this.selectedOptionsArray[s].optVal.id == option.optVal.id){
            flg = false;
          } 
          else {
            if(!this.currentBuildQuestion.multi_selection){
              if(option.qName == this.selectedOptionsArray[s].qName){
                this.selectedOptionsArray.splice(s, 1);
              }
            }
          }
        }
      }
    }
    if(flg){
      this.filterSaveOption(option);
      this.selectedOptionsArray.push(option);
    }
  }

  // REMOVING EXTRA DATA SENT
  filterSaveOption(opt){
    delete opt.opt_style;
    delete opt.qId;
    delete opt.img_style;
    delete opt.text_style;
    if(opt.api_data==undefined) { delete opt.api_data; }
  }

  //REMOVE FROM SELECTED LIST
  removeFromSelectedOptionList(opt){
    var removeEle = -1;
    for(var o=0;o<this.selectedOptionsArray.length;o++){
      
      if(this.selectedOptionsArray[o].optVal!=undefined){
        // TO REMOVE ANY SAVED OPTION FROM THE SAME QUESTION AS IT IS SINGLE SELECT
        if(this.selectedOptionsArray[o].optVal.val == opt.val) { removeEle = o; }
      }
    }
    //WORK ON HERE
    if(removeEle>-1) { this.selectedOptionsArray.splice(removeEle,1); }
  }

  addButtonBorderTextHighlight(element){
    var spanElement = document.createElement("span");
    spanElement.className = "button_border_text";
    spanElement.innerText = "Selected by AI";
    spanElement.classList.add('selected');
    this.ai_highlight_text_style = this.appService.getCSSforClass('button_border_text');
    var styleString = (
      Object.entries(this.ai_highlight_text_style).map(([k, v]) => `${k}:${v}`).join(';')
    );
    spanElement.setAttribute("style",styleString);
    element.appendChild(spanElement);
  }

  addImageHighlight(element){
    var imgElement = document.createElement("img");
    imgElement.className = "option-img";
    imgElement.src = this.aiPoweredImgUrl;
    imgElement.classList.add('selected');
    var styleString = (
      Object.entries(this.aiPoweredImgStyle).map(([k, v]) => `${k}:${v}`).join(';')
    );
    imgElement.setAttribute("style",styleString);
    element.appendChild(imgElement);
  }

  //TO RESET CLASS STYLES OF ALL OPTIONS
  resetCustomOptionsStyle(){
    var opt_classes = this.appService.getNormalSelectClass(this.currentBuildQuestion);
    
    for(var l=0;l<this.customDesignedLabels.length;l++){
      var styleObject = this.appService.applyStyles(opt_classes);
      var styleString = (
        Object.entries(styleObject).map(([k, v]) => `${k}:${v}`).join(';')
      );
      this.customDesignedLabels[l].setAttribute("style",styleString);
    }
  }

  //HIGHLIGHT A PARTICULAR OPTION
  highlightCustomOption(opt){
    var b=(opt.val).trim();
    for(var l=0;l<this.customDesignedLabels.length;l++){
      var a= (this.customDesignedLabels[l].getElementsByClassName("option_value")[0].innerText).trim();
      if(a==b){
        var inp = this.customDesignedLabels[l].querySelector('input');
        if(inp!=undefined){
          if(inp.type == 'checkbox') { inp.checked = true; }
        }
        this.customDesignedLabels[l].classList.add(AppTexts.highlight_selection);
      }
    }
  }

  //NORMLISE A PARTICULAR OPTION
  normalizeCustomOption(opt){
    var b=(opt.val).trim();
    for(var l=0;l<this.customDesignedLabels.length;l++){
      var a= (this.customDesignedLabels[l].getElementsByClassName("option_value")[0].innerText).trim(); 
      if(a==b) { this.customDesignedLabels[l].classList.remove(AppTexts.highlight_selection); }
    }
  }

  // LOOP TO FIND NEXT QUESTION
  loopToNextQuestion(){
    var qFound = false;
    for (var q = 0; q < this.questions_array.length; q++) {
      if (this.questions_array[q].name == this.nextQuestionName) {
        qFound = true;
        this.buildQuestion(this.questions_array[q]);
      }
    }
    if(!qFound) { this.buildQuestion(this.questions_array[0]); }
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.customService.baseConversion(this.fileData);
  }

  uploadImage(ele){
    this.photoInput.nativeElement.value = '';
    this.customService.triggerFunction(ele);
  }

  createInputElementUIArray(){
    this.form_fields.length=0;
    var form_group = this.formBuilder.group({});

    //LIST OF INPUT FIELDS
    var form_element_list =  this.currentBuildQuestion.inputs_ele;
    this.form_present = true;
    

    for(let form_element of form_element_list){
      form_element = this.addPropertyToElement(form_element);

      // For adding only Input Controls
      if(form_element.control){
        var validators_list = this.getDefaultValidatorsForControl(form_element);
        form_group = this.addFormControlsToFormGroup(form_element, form_group, validators_list);
      }

      form_element.style = this.getFormElementStyle(form_element);

      // Adding to UI element List
      this.form_fields.push(form_element);
    }

    this.form = form_group;
    
    this.sortFormElementsByCustomOrder();
    this.previous_opt = null;
  }

  addPropertyToElement(element){
    var element_type_list = ['text','email','number','textarea','date'];
    if(element_type_list.includes(element.type)){
      element.type == 'date' && element.maxDate=='today' ? element.maxDate = new Date() : null;
      element["control"] = this.questionService.getInput(element);
    }
    return element;
  }

  sortFormElementsByCustomOrder(){
    this.form_fields = this.form_fields.sort((a, b) =>
      a.order_by - b.order_by
    );
  }

  getDefaultValidatorsForControl(element){
    if (element.control != undefined) {
      var temp_validators = [];
      if(element.control.required){
        temp_validators.push(Validators.required);
        temp_validators.push(Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/));
      } 
      switch (element.type) {
        case 'email':
          temp_validators.push(Validators.email);
          break;
        case 'number':
          temp_validators.push(Validators.pattern("^[0-9]*$"));
          break;
        case 'phone':
          temp_validators.push(Validators.pattern("^[0-9]*$"));
          break;
        default:
          break;
      }
    }
    return temp_validators;
  }

  addFormControlsToFormGroup(form_element, form_group, validators_list){
    form_group.addControl(form_element.control.key, new FormControl('', validators_list));
    form_group = this.setIfAnyPreviousInputValues(form_element.control.key, form_group);
    return form_group;
  }
  
  getFormElementStyle(element){
    var field_style = this.findClassStyle(element);
    var custom_field_style = this.appService.applyStyles([this.currentBuildQuestion.qID+"_question_input_custom"])
    return {...field_style, ...custom_field_style};
  }

  setIfAnyPreviousInputValues(key, form_group){
    if(this.previous_opt!=undefined && this.previous_opt.value!=undefined && this.previous_opt.value.hasOwnProperty(key)){
      form_group.controls[key].setValue(this.previous_opt.value[key]);
    }
    return form_group;
  }


  // FOR CUSTOM CODE OPERATION
  @HostListener('click', ['$event'])
  onClick(event: any) {   
    this.elRef.nativeElement.blur();
    
    // EXECUTES ON CUSTOM CODE ENABLED
    if(this.pageDesign.custom_code_enabled){
      switch (event.target.name) {
        case "next_button":
          this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);
          this.updateIframeHeight();
          var skip_action = false;
          if(this.currentBuildQuestion.multi_selection){
            if(this.multiOpts.length>0){
              for(var m =0;m<this.multiOpts.length;m++) { this.selectedOptionsArray.push(this.multiOpts[m]); }
              this.nextQuestionName = this.findNextQName(this.selectedOptionsArray[this.selectedOptionsArray.length-1]);
            }
            else{
              var count =1;
              var message =  $localize`Please select at least ${count} option`;
              if(this.currentBuildQuestion.validations!=undefined){
                if(this.currentBuildQuestion.validations.min_select!=undefined){
                  count = this.currentBuildQuestion.validations.min_select;
                  if(count>1){
                    message = $localize`Please select at least ${count} options`;
                  }
                }
              }
              // Display message at bottom of content
              var rect= this.surveyContinueBtn["_elementRef"].nativeElement.getBoundingClientRect();
              this.customService.openSnackBarMessage(message,rect.bottom,'top');
            }
          }
          else{
            if(this.currentBuildQuestion.response_type == "user_input"){
              this.nextQuestionName = this.currentBuildQuestion.next.default;
              var input_elements = document.getElementsByClassName("input_ele");
              if(input_elements.length>0){
                for(var inp =0;inp<input_elements.length;inp++){
                  var input = <HTMLInputElement>input_elements[inp];
                  if(input.required && input.value!=null && input.value!=""){
                    var optionO = {};
                    optionO[AppTexts.Type] = AppTexts.question;
                    optionO[input.name] = input.value;
                    optionO[AppTexts.QuestionnName]= this.currentBuildQuestion.name;
                    var formV = {};
                    formV[input.name] = input.value;
                    this.customService.saveSurveyForm(formV);
                    this.selectedOptionsArray.push(optionO);
                  }
                  else{
                    skip_action = true;
                  }
                }
              }
            }
            else{
              if(this.previous_opt!=undefined && !this.user_clicked){
                this.currentSelectedOption = this.previous_opt;
              }
              this.nextQuestionName = this.findNextQName(this.currentSelectedOption);
              this.addToSelectedOptionList(this.currentSelectedOption);
            }            
          }
          
          if(!skip_action){
            if(this.nextQuestionName == "end"){
              for(var e=0;e<this.pageDesign.element_flow.length;e++){
                if(this.pageDesign.element_flow[e].type == AppTexts.multiOptionElement){
                  this.customService.triggerFunction(this.pageDesign.element_flow[e]);
                }
              }
            }
            else{
              this.currentQuestionBulletPoint = this.currentQuestionBulletPoint +1;
              this.loopToNextQuestion();
            }
            
            //ADD TO LIST                      
            this.customService.saveSelectedQueries(this.selectedOptionsArray);
            this.previous_opt = null;
          }
          break;
        case "back_button":
          this.updateIframeHeight();
          this.custom_previous_press = true;
          this.previousQstn();
          break; 
        case "options":
          this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);
          this.updateIframeHeight();
          this.customDesignedLabels = document.getElementsByClassName("select-btn");
          this.user_clicked = true;
          if(this.customDesignedLabels!=null || this.customDesignedLabels!=undefined){
            for(var c=0;c<this.customDesignedLabels.length;c++){
              const inputNumber = event.target.id.split('_').pop();
              const labelNumber = this.customDesignedLabels[c].id.split('_').pop();
              if(inputNumber==labelNumber){
                var b=(this.customDesignedLabels[c].getElementsByClassName("option_value")[0].innerText).trim();
                for (const property in this.currentBuildQuestion.select_map) {
                  if(this.currentBuildQuestion.select_map[property]!=undefined){
                    var a= (this.currentBuildQuestion.select_map[property].val).trim();
                    if(a==b){
                      var opt = { optVal: this.currentBuildQuestion.select_map[property] };
                      this.currentSelectedOption = opt;
                      this.currentSelectedOption.qName = this.currentBuildQuestion.name;
                      this.currentSelectedOption.type =AppTexts.question;
                      this.user_clicked = true;
                      if(this.currentBuildQuestion.multi_selection){
                        this.enableNextBtn = true;
                        var idc = -1;
                        if(this.multiOpts.length>0){
                          for (var op = 0 ; op < this.multiOpts.length; op++) {
                            if(opt.optVal.id!=undefined){
                              if(this.multiOpts[op].optVal.id == opt.optVal.id){
                                idc = op;
                              }
                            }
                          }
                        }
                        //ADD TO LIST
                        if(idc<0){
                          this.addToMultiSelection(opt);
                          this.highlightCustomOption(opt.optVal);
                        }
                        else{
                          this.removeFromMultiSelection(idc);
                          this.normalizeCustomOption(opt.optVal);
                        }
                      }
                      else{
                        // FIND NEXT QUESTION NAME
                        if (this.currentBuildQuestion.next[property] != undefined) {
                          this.nextQuestionName = this.currentBuildQuestion.next[property];
                        } else {
                          this.nextQuestionName = this.currentBuildQuestion.next.default;
                        }
                        if(this.enableNextBtn && this.aiSelectedValue!=undefined){
                          //RESET ALL SELECTIONS
                          for(var l=0;l<this.customDesignedLabels.length;l++) {
                            this.customDesignedLabels[l].classList.remove(AppTexts.highlight_selection);
                          }
                          this.highlightCustomOption(opt.optVal);
                        } else {
                          //ADD TO LIST
                          this.addToSelectedOptionList(opt);
                          this.customService.saveSelectedQueries(this.selectedOptionsArray);

                          //NEXT PAGE LOADING
                          if(this.nextQuestionName == "end"){
                            for(var e=0;e<this.pageDesign.element_flow.length;e++){
                              if(this.pageDesign.element_flow[e].type ==  AppTexts.multiOptionElement){
                                this.customService.triggerFunction(this.pageDesign.element_flow[e]);
                              }
                            }
                          }
                          else{
                            this.currentQuestionBulletPoint = this.currentQuestionBulletPoint +1;
                            this.loopToNextQuestion();
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          break; 
        default:          
          break;
      }
    }
  }

  // FOR MULTI SELECTION QUESTIONS
  addToMultiSelection(option){
    var flg= true;
    if(this.multiOpts.length>0){
      for(var s=0;s<this.multiOpts.length;s++){
        if(this.multiOpts[s].optVal.val == option.optVal.val) { flg = false; } 
      }
    }
    if(flg) { this.multiOpts.push(option); }
  }
  
  removeFromMultiSelection(index) { this.multiOpts.splice(index, 1); }

  //LOAD CUSTOM CODE
  loadCustomQuestionScreen(qtn) {
    this.aiSelectedValue = null;
    // IF CUSTOM CODE IS ENABLED FOR SELECTED QUESTION
    if(qtn.custom_code_enabled){    
      var custom_key = qtn.custom_code_key_name;
      //DECODE BASE64 CUSTOM CODE TO STRING
      this.htmlText = atob(this.pageDesign[custom_key]);  
    } 
    else {
      this.htmlText = atob(this.pageDesign.custom_code_1);
    }
    //CREATE OPTIONS
    this.updateOptionsList(qtn);
    this.customDesign = true;
  }

  //UPDATE OPTIONS LIST WHEN IN CUSTOM CODE DESIGN
  updateOptionsList(qtn){
    var enableSingleAI = true;
    
    // WAIT TO LOAD AND REMOVE EXTRA OPTIONS
    setTimeout(() => {
      // CREATE BULLETS
      if(this.quizSteps!=undefined) { this.createProgressBullets(); }
      this.customDesignedLabels = null;
      
      document.getElementById(AppTexts.question).innerText = qtn.question;
      
      if(qtn.image!=undefined){
        if(document.getElementById(AppTexts.QuestionImage)!=undefined) { document.getElementById(AppTexts.QuestionImage).setAttribute("src",qtn.image.src); }
      } else {        
        if(document.getElementById(AppTexts.QuestionImage)!=undefined){
          setTimeout(() => {
            document.getElementById(AppTexts.QuestionImage).setAttribute(AppTexts.style,"display:none!important");
            this.updateIframeHeight();
          }, 100);
        }
      }
    
      //FETCH ALL OPTIONS BUTTONS
      this.customDesignedLabels = document.getElementsByClassName("select-btn");
      var opt_container = document.getElementById('buttons-container');
      this.customDesignedLabels[0].classList.remove(AppTexts.highlight_selection);
      var temp_option_ele = this.customDesignedLabels[0];
      if(temp_option_ele!=undefined){
        temp_option_ele.classList.remove(AppTexts.highlight_selection);
        var elements = document.getElementsByClassName('selected');
        if(elements!=undefined){
          while(elements.length > 0) { elements[0].parentNode.removeChild(elements[0]); }
        }
      }
      
      if(opt_container!=undefined){
        while (opt_container.firstChild) { opt_container.removeChild(opt_container.firstChild); }
      }
      
      var options_map = qtn.select_map;
      var o_index=1;
      var singleHighlight = false;
      this.aiSelectedValue = null;

      // CREATE 'OPTION' NUMBER OF BUTTON ELEMENT
      for (var key in options_map) {
        var temp_key = key;
        
        // CREATE NEW ELEMENT COPY
        var opt_element = temp_option_ele.cloneNode(true);
        opt_element.setAttribute("style","display:flex!important");
        opt_element.id = "option_"+o_index;
        opt_element.setAttribute("id","option_"+o_index);
        opt_element.getElementsByTagName("input")[0].id = "input_"+o_index;
        opt_element.getElementsByClassName("option_value")[0].innerText = options_map[temp_key].val;
        o_index = o_index+1;
        var apiKeyData =null;

        //CHECK IF OPTION IS API VALUE MAPPED
        if (options_map[temp_key].tag != "null") {          
          apiKeyData = this.customService.checkMatchWithSelfieTag(options_map[temp_key].tag);
          this.customService.resetAiSelected();
        }
        
        // IF BUTTON HAS BACKGROUND IMAGE
        if(options_map[temp_key].img!=undefined && options_map[temp_key].img.bgimage !=undefined){
          opt_element.getElementsByTagName("div")[0].setAttribute("style","background-image: url('"+options_map[temp_key].img.bgimage+"')");
        }  

        // FOUND TAG MATCHED TO API RESPONSE
        if (apiKeyData!=undefined && apiKeyData!=null) {
          this.aiSelectedValue = options_map[temp_key];
          this.enableNextBtn = true;
          this.selectedOptionStatus = true;
          var a= (opt_element.getElementsByClassName("option_value")[0].innerText).trim();
          var b= (this.aiSelectedValue.val).trim();
          if(a==b){
            if(enableSingleAI) { enableSingleAI = false; }
            switch (apiKeyData.highlight_type) {
              case "button_border_text":
                this.addButtonBorderTextHighlight(opt_element);
                break;
              case "image":
                this.addImageHighlight(opt_element)
                break;
              default:
                break;
            }
          
            // TO HIGHLIGHT ONLY FIRST AI SELECTED OPTION
            if(!singleHighlight){
              var opt = { optVal: this.aiSelectedValue }; 
              this.currentSelectedOption = opt;
              this.currentSelectedOption.qName = this.currentBuildQuestion.name;
              this.highlightCustomOption(this.currentSelectedOption.optVal);

              if(!this.custom_previous_press) { opt_element.classList.add(AppTexts.highlight_selection); }
              singleHighlight = true;            
            }

          }
          else {
            opt_element.classList.remove(AppTexts.highlight_selection);
          }
        } 
        
        var opt_img_classes = [];

        if(options_map[temp_key].img!=undefined){
          if (options_map[temp_key].img.class != undefined) { opt_img_classes = options_map[temp_key].img.class; }      
        }
        if(options_map[temp_key].img!=undefined && options_map[temp_key].img!="" && options_map[temp_key].img!="null"){
          this.addOptionImage(opt_element, options_map[temp_key], opt_img_classes);
        }

        // ADDING OPTION BUTTON TO CONTAINER
        opt_container.appendChild(opt_element);
      }

      if(qtn.response_type=="user_input") { this.enableNextBtn = true; }
    
      if(this.enableNextBtn){
        document.getElementById(AppTexts.NextButton).style.display = StyleValues.block;
      } 
      else {
        document.getElementById(AppTexts.NextButton).style.display = StyleValues.none;
      }
      this.updateIframeHeight();
    }, 300);
    
  }

  addOptionImage(element, optionObject, styleClass){
    var imgElement = document.createElement("img");
    imgElement.className = "option-img";
    imgElement.src = optionObject.img.i_url;
    var styleObject = this.appService.applyStyles(styleClass)
    var styleString = ( Object.entries(styleObject).map(([k, v]) => `${k}:${v}`).join(';') );
    imgElement.setAttribute("style",styleString);
    element.prepend(imgElement);
  }

  //RETURNS NEGATIVE IF NO MATCHING OPTION FOUND
  checkInMultiSelection(option){
    var index = -1;
    if(this.multiOpts.length>0){
      for (var op = 0 ; op < this.multiOpts.length; op++) {
        if(this.multiOpts[op].optID == option.optID) { index = op; }
      }
    }
    return index;
  }

  //APPLY NORMAL SELECTION STYLE
  applyNormalSelectionCSS(option){
    var optionSclass = this.appService.getNormalSelectClass(this.currentBuildQuestion);
    option.optionClasses = "option_selection";
    option.opt_style = this.appService.applyStyles(optionSclass);
    return option;
  }

  //APPLY HIGHLIGHT SELECTION STYLE
  applyHighLightSelectionCSS(option){
    var optionSclass = this.appService.getSelectionHighlightCss(this.currentBuildQuestion);
    // Adding selection class - highlight
    option.optionClasses = "option_selection highlighted_selection";
    option.opt_style = this.appService.applyStyles(optionSclass);
    return option;
  }

  //CREATE PROGRESS BULLETS IN HEADER
  createProgressBullets(){
    this.customBulletPoints = null;
    this.customBulletPoints = document.getElementsByClassName("round_point");
    var copy_point = this.customBulletPoints[0];
    var progress_bar = document.getElementById('progress_bar');
    
    // RESET BULLETS
    if(progress_bar != null){
      while (progress_bar.firstChild) { progress_bar.removeChild(progress_bar.firstChild); }
    }
      
    for (let index = 0; index < this.questions_array.length; index++) {
      var points = copy_point.cloneNode(true);
      points.id ="round_point_"+index;
      if(this.currentQuestionBulletPoint >= index){
        points.setAttribute("class","stop round_point");
      }
      else{
        points.setAttribute("class","round_point");
      }
      progress_bar.appendChild(points);
    }
    progress_bar.setAttribute("style","visibility:visible");
  }
  
  // SENDING EVENT TO GOOGLE ANALYTICS
  sendToGA(option){
    if(option.optVal!=undefined){
      if(option.optVal.tag !="null"){
        var opt1 = { option: option.optVal.tag };
        this.appService.sentEventData(AppTexts.clickEventName, 'Tag', 'Selected', option.optVal.tag, opt1);
      }
    }
  }
  
  
  skipFormQuestion(ele){
    this.sendSkipToAnalytics();

    this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);
    this.customService.setCurrentQuestion(this.currentBuildQuestion);
    for (var q = 0; q < this.questions_array.length; q++) {
      if (this.questions_array[q].name == ele[AppTexts.NextQuestion]) {
        this.currentBuildQuestion = this.questions_array[q];
      }
    }
      
    switch (ele.function_name) {
      // LOAD NEXT QUESTION
      case AppTexts.NextQuestion: 
        this.buildQuestion(this.currentBuildQuestion);
        break;
      // LOAD NEW SCREEN
      default:
        this.customService.triggerFunction(ele);
        break;
    }
  }

  skipQuestion(){
    this.appService.addToScreenHistory(this.currentBuildQuestion.name,AppTexts.question);

    // Remove if any previous selections are added in list
    if(this.selectedOptionsArray.length > 0) {
      var i = this.selectedOptionsArray.length-1;

      // If only one selection present
      if(i==0){
        if (this.selectedOptionsArray[i].qName == this.currentBuildQuestion.name) { 
          this.selectedOptionsArray.pop(); 
        } 
      }
      else{

        // Remove pre-selections of same question
        while (i>0) {
          if (this.selectedOptionsArray[i].qName == this.currentBuildQuestion.name) { 
            this.selectedOptionsArray.pop(); 
          } 
          i=i-1;
        }
      }
    }

    // If Skip Applied enable back button
    this.enableBackBtn = true;
    
    // Setting next question screen
    this.nextQuestionName = this.currentBuildQuestion.next.default;
    
    // Final survey question
    if(this.nextQuestionName == "end"){
      if(this.pageDesign.element_flow.length>0){
        var eles = this.pageDesign.element_flow;
        for(var e=0;e<eles.length;e++){
          if(eles[e].type ==  AppTexts.multiOptionElement){
            this.clickedBtn = eles[e];
          }
        }
      }
      this.customService.triggerFunction(this.clickedBtn);
    }
    else{
      this.loopToNextQuestion();
    }
  }
  
  updateIframeHeight(){
    if(this.pageDesign!=undefined){
      if(this.pageDesign.name!=undefined){
        var ele = document.getElementById(this.pageDesign.name);
        if(this.currentBuildQuestion!=undefined){
          if(this.currentBuildQuestion.container_style!=undefined){
            var mob = []
            var common = this.currentBuildQuestion.container_style.common;
            common.push(this.currentBuildQuestion.qID+"_question_screen_custom");
            if(this.isMobile){
              if(this.currentBuildQuestion.container_style.mobile!=undefined){
                mob =this.currentBuildQuestion.container_style.mobile;
              }
              mob.push(this.currentBuildQuestion.qID+"_question_screen_mob_custom")
            }

            const final_classes =  common.concat(mob);
            this.survey_screen_style = this.appService.applyStyles(final_classes);
            
          }
          else{
            this.survey_screen_style = null;
          }
        }
        
        if(ele!=null && ele!=undefined){
          var offsetHeight = ele.offsetHeight;
          this.appService.sentHeight(offsetHeight);
        }
      }
    }
  }

  ngAfterViewChecked() { this.updateIframeHeight(); }

  ngAfterContentChecked() { this.updateIframeHeight(); }

  ngOnChanges() { this.updateIframeHeight(); }
  
  ngAfterViewInit(){ this.updateIframeHeight(); }

}